import { uri } from '../utils/config';
import { HTTP } from './secure/http';
import { ordersFormating } from './ordersFormating';

export const getActiveEvents = async (placeState) => {
  const placeId = placeState?.place?.id;
  if (!placeId) {
    console.log('NO PLACE ID ACTIVE EVENTS');
    return {
      error: true,
    };
  }

  const {
    products: { productId__product },
  } = placeState;

  if (!productId__product) {
    console.log('NO productId__product');
    return {
      error: true,
    };
  }

  let data = null;
  try {
    const response = await HTTP.get({
      path: `${uri.orders}/api/events/${placeId}`,
    });
    data = response.data;
  } catch (error) {
    console.log('ERROR', error)
  }

  if (!data) {
    console.log('DATA UNAVAILABLE EVENTS');
    return {
      error: true,
    };
  }

  const { orders, userId__user, callId__call } = data;
  if (!orders || !userId__user || !callId__call) {
    console.log('DATA PARTIALY AVAILABLE');
    return {
      error: true,
    };
  }

  const ordersFormated = ordersFormating(orders, productId__product);

  const initializedData = { 
    orders: ordersFormated,
    users: { userId__user },
    calls: { callId__call },
    initialized: true 
  };

  return initializedData;
};